import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'

import store from '../store'

import parameters from './parameters'

const initUserJwt = () => {
    const storedUserToken = store.state.userToken
    if (storedUserToken) {
        Vue.axios.defaults.headers.common['Authorization'] = `Token ${storedUserToken}`
    }
}

const ApiService = {
  init(contextKey) {
    Vue.use(VueAxios, axios)
    Vue.axios.defaults.baseURL = parameters.api.baseUrl
    if (contextKey) {
      Vue.axios.defaults.baseURL = 'MP' === contextKey
        ? parameters.api.baseUrlContextPattern.replace('{context}.', '')
        : parameters.api.baseUrlContextPattern.replace('{context}', contextKey)
    }
  },

  getPlaceContext() {
    return Vue.axios.get(`/2/place-context.json`)
  },

  fetchPlaces() {
    return Vue.axios.get(`/2/places.json`)
  },

  getSession() {
    initUserJwt()

    return Vue.axios.get('/1/users/session.json')
  },

  getWorkshops(search) {
    /**
     * #Bricolette
     */
    const workshopsLocales = store.state.workshopsLocales.map(locale => `locales[]=${locale}`).join('&')

    return Vue.axios.get(
      `/1/workshops.json?placeCode=${store.state.placeCode}&context_key=${store.state.placeContext.key}&temporalScope=futures&locationScope=place&${workshopsLocales}&q=${search}`
    );
  },

  getCurrentUserWorkshops() {
    initUserJwt()

    return Vue.axios.get('/1/workshops/mine.json?expand[]=workshop.place')
  },

  loginOrRegister(userData) {
    const loginOrRegisterData = {
      locale: userData.locale,
      email: userData.email,
      firstname: userData.firstname || undefined,
      lastname: userData.lastname || undefined,
      address: userData.address || undefined,
      phone: userData.phone || undefined,
      loyalty_card_number: userData.loyalty_card_number || undefined,
    }

    return Vue.axios.post(`/1/workshops/login-register.json`, loginOrRegisterData)
  },

  registerToWorkshop(workshopUuid) {
    initUserJwt()

    return Vue.axios.post(`/1/workshops/${workshopUuid}/register.json`)
  },

  unregisterToWorkshop(workshopUuid, customerPayload) {
    return Vue.axios.post(`/1/workshops/${workshopUuid}/unregister.json`, {
      cI: customerPayload.customerId,
      cT: customerPayload.customerOCT,
    })
  },
}

export default ApiService
